import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueMeta from 'vue-meta'

Vue.use(Vuetify);
Vue.use(VueMeta);

export default new Vuetify({
});
